import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import DashboardLayout from '../../layouts/DashboardLayout';
import { runStandardRazorpayCheckout } from '../../services/paymentsApi';

/**
 * App-admin demo for Razorpay Standard Web Checkout (/api/create-order + /api/verify-payment).
 */
const RazorpayCheckoutDemo = () => {
  const [amountRupees, setAmountRupees] = useState('10');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handlePay = async () => {
    setError('');
    setSuccess('');
    const rupees = Number(amountRupees);
    if (!Number.isFinite(rupees) || rupees < 1) {
      setError('Enter at least ₹1.00');
      return;
    }

    setBusy(true);
    try {
      const result = await runStandardRazorpayCheckout({
        amountPaise: Math.round(rupees * 100),
        receipt: `demo_${Date.now()}`,
        description: 'Razorpay integration test',
        customer: { name: 'Test User', phone: '9999999999' },
        onDismiss: () => {},
      });
      setSuccess(
        `Payment verified. Order: ${result.orderId}, Payment: ${result.checkout.razorpay_payment_id}`,
      );
    } catch (err) {
      if (err?.message !== 'Payment cancelled') {
        setError(err?.message || 'Payment failed');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <DashboardLayout>
      <Container maxWidth="sm" sx={{ py: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Razorpay Standard Checkout (test)
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Uses POST /api/create-order and POST /api/verify-payment. Minimum ₹1.00.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}

          <TextField
            fullWidth
            label="Amount (₹)"
            type="number"
            inputProps={{ min: 1, step: 0.01 }}
            value={amountRupees}
            onChange={(e) => setAmountRupees(e.target.value)}
            sx={{ mb: 2 }}
          />

          <Button
            variant="contained"
            fullWidth
            disabled={busy}
            onClick={handlePay}
            startIcon={busy ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {busy ? 'Processing…' : 'Pay with Razorpay'}
          </Button>
        </Paper>
      </Container>
    </DashboardLayout>
  );
};

export default RazorpayCheckoutDemo;
